<template>
  <div class="index">
    <div class="container">
      <!--      第一层 轮播-->
      <div class="intro">
        <div class="swiper-box">
          <swiper :options="swiperOptions">
            <swiper-slide v-for="(item , idx) in sliderList" :key="idx">
              <a v-bind:href="'/activity/'+item.id" target="_blank">
                <img :src="item.img">
              </a>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
          </swiper>
        </div>
        <div class="intro-right">
          <div class="user">
            <router-link to="/profile"><img src="~@/static/imgs/avatar.png" alt=""></router-link>
            <template v-if="this.$store.state.username">
              <p class="username">{{ this.$store.state.username.slice(0, 3) }} ***
                {{ this.$store.state.username.slice(7, 11) }}</p>
              <router-link to="/orderList" class="login-button">我的订单</router-link>
              <router-link to="/collect" class="login-button">搜藏中心</router-link>

            </template>
            <template v-else>
              <p class="username">Hi！你好</p>
              <router-link to="/login" class="login-button">登录</router-link>
              <router-link to="/register" class="login-button">注册</router-link>
            </template>

          </div>
          <div class="code">
            <img src="~@/static/imgs/goodImg/weixin.jpg" alt="">
            <p class="app-name">扫码关注</p>
          </div>
        </div>
      </div>
      <!--公告  to-do 上下-->
      <div class="notice">
        <span>公告</span><img src="~@/static/imgs/notice.png" alt="">
        <p>{{ notice }}</p>
      </div>

      <!--      第三层 新品推荐-->
      <div class="shop-new">
        <h3 class="cate-word">精品推荐</h3>
        <div class="wrap-shop">
          <!-- <div class="new-intro">
            <img src="~@/static/imgs/1623246686.jpeg" alt="新品推荐"> -->
            <!-- <p>新品推荐</p>
            <p>小编精选</p>
            <p>货优质廉</p> -->
          <!-- </div> -->
          <div class="new-list">
            <div class="shop-item" v-for="item in newList" :key="item.id">
              <!-- <span class="flag new-pro">新品</span> -->
              <div class="item-img">
                <router-link :to="'/product/'+item.id" target="_blank"><img v-lazy="item.cover" :alt="item.title"></router-link>
              </div>
              <div class="item-info" @click="goProduct(item.id)">
                <router-link :to="'/product/'+item.id" target="_blank"><h3 class="title">{{ item.title }}</h3></router-link>
                <!--                <p class="desc">{{ item.desc.slice(0, 4) }}</p>-->
                <p class="price">{{ item.price }}元</p>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!--    emit 进行组件之间的传递值-->
    <modal
        title="提示"
        sureText="查看购物车"
        btnType="1"
        modalType="middle"
        v-bind:showModal="showModal"
        v-on:submit="goToCart"
        v-on:cancel="showModal=false">
      <template v-slot:body>
        <p>商品添加成功！</p>
      </template>
    </modal>
  </div>
</template>

<script>
import {swiper, swiperSlide} from 'vue-awesome-swiper'
// import 'swiper/css/swiper.css'
import Modal from "../components/Modal";

export default {
  name: "index",
  components: {
    swiper,
    swiperSlide,
    Modal
  },
  // props: ['category'],
  data() {
    return {
      showModal: false,
      swiperOptions: {
        autoplay: true,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }
      },
      //http://mi.futurefe.com/imgs/slider/slide-1.jpg
      sliderList: [
        {
          img: require("@/static/imgs/goodImg/202212021801342738M4_0.jpg")
        },
        {
          img: require("@/static/imgs/goodImg/202302281745532537Ge_0.jpg")
        }
      ],
      category: [],
      newList: [
        {
          id: 1,
          cover: require("@/static/imgs/goodImg/Snipaste_2023-07-21_17-59-29.png"),
          title: "流量日包（1GB）",
          price: "4"
        },
        {
          id: 2,
          cover: require("@/static/imgs/goodImg/Snipaste_2023-07-21_18-00-20.png"),
          title: "流量日包（2GB）",
          price: "8"
        },
        {
          id: 3,
          cover: require("@/static/imgs/goodImg/Snipaste_2023-07-21_18-00-33.png"),
          title: "流量3日包（3GB）",
          price: "15"
        },
        {
          id: 4,
          cover: require("@/static/imgs/goodImg/Snipaste_2023-07-21_18-00-52.png"),
          title: "流量7日包（5GB）",
          price: "30"
        },
        {
          id: 5,
          cover: require("@/static/imgs/goodImg/Snipaste_2023-07-21_18-01-20.png"),
          title: "流量5日包（10GB）",
          price: "35"
        },
      ],
      notice: "产品热销中～"
    }
  },
  mounted() {
  },
  methods: {
    goProduct() {
    },
    addCart() {
      this.showModal = true;
    },
    goToCart() {
      // this.$router.push('/cart');
      let routeData = this.$router.resolve({path: '/cart'});
      window.open(routeData.href, '_blank');
    },
  },

}
</script>

<style lang="scss">
@import '../assets/scss/swiper-bundle.min.css';
.index {
  margin-top: 3px;
  background-color: #f5f5f5;

  .container {

    margin: 0 auto;
    width: 1190px;


    .intro {
      height: 461px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .nav-menu {
        // 使用该属性 可以不包含 padding
        box-sizing: border-box;
        // 绝对定位 相对于 intro类的
        position: absolute;
        z-index: 9;

        background-color: #99999969;
        width: 200px;
        height: 460px;
        padding: 20px 0;

        .wrap-menu {

          .menu-item {


            height: 35px;
            line-height: 35px;

            &:hover {
              background-color: #FF6600;

              .children {
                display: block;
              }
            }

            .children {
              display: none;
              background-color: #FFFFFF;
              width: 988px;
              min-height: 459px;
              position: absolute;
              left: 200px;
              top: 0;
              border: 1px solid #E5E5E5;

              .warp-child {
                &:first-child {
                  margin-top: 22px;
                }

                //&:last-child {
                //  margin-bottom: 22px;
                //}

                //padding: 22px 0;

                .category-block {
                  .category-flex {
                    display: flex;
                    justify-items: center;

                    .second-menu {
                      color: #000000;
                      font-size: 18px;
                      min-width: 50px;
                    }

                    ul {
                      display: flex;
                      flex-direction: row;
                      flex-wrap: wrap;
                      //justify-content: flex-start;

                      li {


                        a {
                          color: #FF6600;
                        }
                      }
                    }
                  }
                }

                .line {
                  //width: 900px;
                  margin-top: 10px;
                  margin-bottom: 10px;
                  border-bottom: 2px solid #F8F8F8;
                }

              }
            }

            a {
              // 给a一个
              position: relative;
              color: #FFFFFF;
              font-size: 14px;
              display: block;
              padding-left: 25px;

              &:after {
                // 相对于a的绝对定位
                position: absolute;
                content: ' ';
                right: 30px;
                top: 10px;
                width: 10px;
                height: 15px;
                background: url("~@/static/imgs/icon-arrow.png") no-repeat center;
                background-size: contain;
              }


            }
          }
        }
      }

      .swiper-box {
        border-radius: 5px;
        width: 950px;

        .swiper-container {
          height: 460px;

          img {
            border-radius: 5px;
            height: 100%;
            width: 100%;
          }
        }
      }

      .intro-right {
        margin-top: 1px;
        margin-left: 5px;
        background: #F5F5F5;
        width: 240px;
        height: 460px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .user {
          border-radius: 5px;
          background-color: #FFFFFF;
          margin-bottom: 5px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          justify-content: space-around;
          align-items: center;
          height: 262px;
          width: 235px;

          img {
            margin-top: 10px;
            text-align: center;
            width: 47px;
            height: 47px;
            border-radius: 50%;
            border: 4px solid #E5E5E5
          }

          .username {
            padding-top: 10px;
            font-size: 16px;
            text-align: center;
            font-weight: 500;
            white-space: nowrap;
            width: 6em;
            overflow: hidden;
            text-overflow: ellipsis;
            margin: 0 auto;
            padding-bottom: 5px;
            color: #6c757d;
          }

          .login-button {
            height: 40px;
            width: 118px;
            text-align: center;
            margin: 5px auto 15px auto;
            background: #fff;
            border: 1px solid #e5e5e5;
            border-radius: 40px;
            font-size: 14px;
            color: #333;
            transition: background-color 0.5s;
            display: block;
            line-height: 38px;
          }
        }

        .code {
          // 好的办法是加 用padding  box-sizing: border-box;
          border-radius: 5px;
          background-color: #FFFFFF;
          width: 235px;
          height: 194px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          img {
            width: 100px;
            height: 100px;
          }

          .app-name {
            font-size: 16px;
            color: #222222;
            font-weight: 500;
          }
        }
      }


    }

    .shop-recommend {
      display: flex;
      align-items: center;
      margin-top: 5px;

      .recom-left {
        width: 200px;
        height: 180px;
        //border: 1px solid #E5E5E5;
        display: flex;
        margin-right: 10px;
        background-color: #FFFFFF;
        justify-content: center;
        align-items: center;

        img {
          width: 100px;
          height: 100px;
        }
      }

      .recom-right {
        width: 990px;
        height: 180px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .recom-list {
          width: 235px;
          height: 180px;
          background-color: #FFFFFF;

          .recom-img {
            width: 160px;
            height: 160px;
            margin: 0 auto;

            a {
              &:last-child {
                margin-right: 0;
              }

              img {
                margin-top: 5px;
                height: 100%;
                width: 100%;
              }
            }
          }
        }


      }
    }

    .notice {
      display: flex;
      align-items: center;
      margin: 10px 0;
      padding: 5px 0;
      height: 35px;
      line-height: 35px;
      background: #FFFFFF;

      span {
        margin-left: 10px;
        margin-right: 5px;
        color: #FF6600;
        font-size: 16px;
        font-weight: bold;
      }

      p {
        margin: 0 10px;
        font-size: 14px;
      }

      img {
        width: 15px;
        height: 15px;
      }
    }

    .shop-new {
      margin-top: 5px;
      display: flex;
      flex-direction: column;
      position: relative;
      padding-bottom: 20px;

      .cate-word {
        padding: 15px 0;
        font-size: 22px;
        height: 21px;
        line-height: 21px;
        color: #333;
      }

      .wrap-shop {
        display: flex;
        justify-content: space-between;

        .new-intro {
          width: 200px;
          height: 280px;
          background: #FFFFFF;
          display: flex;
          align-items: center;
          flex-direction: column;
          justify-content: center;
          position: absolute;

          img {
            width: 200px;
          }

          p {
            font-size: 16px;
            font-weight: bold;
            color: #FF6600;
            padding-top: 20px;
          }
        }

        .new-list {
          // https://www.jianshu.com/p/e8f236fcf515
          // 换行布局 wrap
          display: flex;
          justify-content: space-between;
          text-align: center;
          flex-wrap: wrap;
          width: 100%;

          .shop-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-evenly;
            background-color: #FFFFFF;
            width: 230px;
            height: 280px;
            margin-bottom: 10px;

            .flag {
              display: inline-block;
              width: 67px;
              color: #FFFFFF;
              height: 24px;
              font-size: 14px;
              line-height: 24px;
              background-color: aquamarine;

              &.new-pro {
                background-color: #80c58a;
              }

              &.kill-pro {
                background-color: #FF6600;
              }
            }

            .item-img {
              width: 100px;
              height: 100px;
              margin: 0 auto;

              img {
                width: 100%;
                height: 100%;
              }
            }

            .item-info {
              .title {
                //margin-top: 10px;
                font-size: 14px;
                color: #333;
                padding: 0 8px;
                line-height: 20px;
                font-weight: 700;
              }

              .desc {
                color: #999;
                line-height: 13px;
                margin: 10px auto 13px
              }

              .price {
                color: #FF6600;
                font-size: 14px;
                font-weight: 700;
                //cursor: pointer;

                //&:after {
                //  // 垂直居中
                //  vertical-align: middle;
                //  margin-left: 3px;
                //  content: ' ';
                //  display: inline-block;
                //  width: 28px;
                //  height: 28px;
                //  background: url("~@/static/imgs/cart (2).png") no-repeat center;
                //  background-size: 25px;
                //}
              }
            }

            //  https://blog.csdn.net/tenggeer0789/article/details/89478859
            // 阴影实现
            &:hover {
              -webkit-box-shadow: #ccc 0px 10px 10px;
              -moz-box-shadow: #ccc 0px 10px 10px;
              box-shadow: #ccc 0px 10px 10px;
              transition: all .2s;
            }
          }

        }
      }
    }

    .shop-category {
      // 注意需要使用height来撑高度 而不是margin-bottom
      margin-top: 5px;
      // 780px
      height: 680px;
      display: flex;
      flex-direction: column;

      .cate-word {
        padding: 20px 0;
        font-size: 22px;
        height: 21px;
        line-height: 21px;
        color: #333;
      }

      .wrap-category {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 600px;

        .brandlist {
          height: 600px;
          width: 200px;
          background: #FFFFFF;
          margin-right: 10px;
          display: flex;
          align-items: center;
          flex-direction: column;

          .brand {
            margin-top: 10px;
            height: 100px;
            width: 100px;
            margin-bottom: 10px;
            background: #FFFFFF;


            img {
              width: 100%;
              height: 100%;
            }
          }

        }

        .category-list {

          display: flex;
          width: 990px;
          height: 600px;
          justify-content: space-between;
          text-align: center;
          flex-wrap: wrap;
          align-content: space-between;

          .shop-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-around;
            background-color: #FFFFFF;
            width: 236px;
            height: 295px;
            //margin-bottom: 10px;

            .flag {
              display: inline-block;
              width: 67px;
              color: #FFFFFF;
              height: 24px;
              font-size: 14px;
              line-height: 24px;
              background-color: aquamarine;

              &.new-pro {
                background-color: #80c58a;
              }

              &.kill-pro {
                background-color: #FF6600;
              }
            }

            .item-img {
              //padding-top: 10px;
              width: 160px;
              height: 160px;
              margin: 0 auto;

              img {
                width: 100%;
                height: 100%;
              }
            }

            .item-info {
              .title {
                margin-top: 10px;
                font-size: 14px;
                color: #333;
                padding: 0 8px;
                line-height: 20px;
                font-weight: 700;
              }

              .desc {
                color: #999;
                line-height: 13px;
                margin: 10px auto 13px
              }

              .price {
                color: #FF6600;
                font-size: 14px;
                font-weight: 700;
                //cursor: pointer;

                //&:after {
                //  // 垂直居中
                //  vertical-align: middle;
                //  margin-left: 3px;
                //  content: ' ';
                //  display: inline-block;
                //  width: 28px;
                //  height: 28px;
                //  background: url("~@/static/imgs/cart (2).png") no-repeat center;
                //  background-size: 25px;
                //}
              }
            }

            //  https://blog.csdn.net/tenggeer0789/article/details/89478859
            // 阴影实现
            &:hover {
              -webkit-box-shadow: #ccc 0px 10px 10px;
              -moz-box-shadow: #ccc 0px 10px 10px;
              box-shadow: #ccc 0px 10px 10px;
              transition: all .2s;
            }
          }
        }
      }

      //.ads {
      //  margin-top: 20px;
      //  height: 100px;
      //
      //  img {
      //    height: 100%;
      //    width: 100%;
      //  }
      //}
    }

    .shop-guess {
      margin-top: 5px;
      height: 380px;
      display: flex;
      flex-direction: column;

      .cate-word {
        padding: 15px 0;
        font-size: 22px;
        height: 21px;
        line-height: 21px;
        color: #333;
      }

      .wrap-shop {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .new-list {
          // https://www.jianshu.com/p/e8f236fcf515
          // 换行布局 wrap
          display: flex;
          width: 1190px;
          justify-content: space-between;
          text-align: center;
          flex-wrap: wrap;

          .shop-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-evenly;
            background-color: #FFFFFF;
            width: 230px;
            height: 280px;

            .flag {
              display: inline-block;
              width: 67px;
              color: #FFFFFF;
              height: 24px;
              font-size: 14px;
              line-height: 24px;
              background-color: aquamarine;

              &.new-pro {
                background-color: #80c58a;
              }

              &.kill-pro {
                background-color: #FF6600;
              }
            }

            .item-img {
              width: 160px;
              height: 160px;
              margin: 0 auto;

              img {
                width: 100%;
                height: 100%;
              }
            }

            .item-info {
              .title {
                font-size: 14px;
                color: #333;
                padding: 0 8px;
                line-height: 20px;
                font-weight: 700;
              }

              .desc {
                color: #999;
                line-height: 13px;
                margin: 10px auto 13px
              }

              .price {
                color: #FF6600;
                font-size: 14px;
                font-weight: 700;
                //cursor: pointer;

                //&:after {
                //  // 垂直居中
                //  vertical-align: middle;
                //  margin-left: 3px;
                //  content: ' ';
                //  display: inline-block;
                //  width: 28px;
                //  height: 28px;
                //  background: url("~@/static/imgs/cart (2).png") no-repeat center;
                //  background-size: 25px;
                //}
              }
            }

            //  https://blog.csdn.net/tenggeer0789/article/details/89478859
            // 阴影实现
            &:hover {
              -webkit-box-shadow: #ccc 0 10px 10px;
              -moz-box-shadow: #ccc 0 10px 10px;
              box-shadow: #ccc 0 10px 10px;
              transition: all .2s;
            }
          }

        }
      }
    }
  }

}
</style>